import React from 'react';
import { Card, Typography, Chip, Grid } from '@mui/material';
import { styled } from '@mui/system';

const StyledCard = styled(Card)(({ theme }) => ({
  margin: theme.spacing(2, 0),
  padding: theme.spacing(3),
  backgroundColor: '#fafafa',
}));

const Title = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const CategoryChip = styled(Chip)(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

export default function InfoPanel({ distinctPagesCount, selectedCategories }) {
  return (
    <StyledCard>
      <Title variant="h5" align="center">
        Search Summary
      </Title>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="subtitle1" align="center">
            Number of Scanned Articles
          </Typography>
          <Typography variant="h4" align="center" color="primary">
            {distinctPagesCount}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={8}>
          <Typography variant="subtitle1" align="center">
            Categories Selected
          </Typography>
          <Grid container justifyContent="center">
            {selectedCategories.map((category) => (
              <CategoryChip
                key={category}
                label={category}
                variant="outlined"
              />
            ))}
          </Grid>
        </Grid>
      </Grid>
    </StyledCard>
  );
}